// extracted by mini-css-extract-plugin
export default {"BorderedSwitch":"SettingsCoverImage_BorderedSwitch__sqyKn","CTAContainer":"SettingsCoverImage_CTAContainer__QqzlO","Heading":"SettingsCoverImage_Heading__eO4oX"};